import React from 'react';
import { FormProps } from 'util/Form';
import StateFormItem from 'components/shared/AddressFormSection/StateFormItem';

interface StateQuestionFormItemProps extends FormProps {
  fieldName: string;
  addressFieldName: string;
  countryFieldName?: string;
}

const StateQuestionFormItem: React.FunctionComponent<StateQuestionFormItemProps> = ({
  fieldName,
  addressFieldName,
  countryFieldName,
  required,
  disabled,
}) => {
  return (
    <StateFormItem
      fieldName={fieldName}
      addressFieldName={addressFieldName}
      countryFieldName={countryFieldName}
      required={required}
      disabled={disabled}
      label=""
      generateControlName={false}
    />
  );
};
export default StateQuestionFormItem;
